import { LANGUAGE_KEY } from './constants/codes'

export const languageCode = {
  set: (language?: string | null, query?: string) => {
    const current = localStorage.getItem(LANGUAGE_KEY) || navigator.language
    localStorage.setItem(LANGUAGE_KEY, language || query || current)
  },
  get: () => localStorage.getItem(LANGUAGE_KEY) || navigator.language
}
